import React, { memo } from "react";
import { useSelector } from "react-redux";
import Loading from "./Loading";

const Switch = ({ getValue, onChange, name, value, disabled = false }) => {
  const { isFormLoading } = useSelector((state) => state.ui);
  return (
    <div className="form-switch form-switch-sm">
      <input
        className="form-check-input"
        type="checkbox"
        name={name}
        checked={getValue}
        onChange={onChange}
        onFocus={(e) => e.target.blur()}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default memo(Switch);
